"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caption = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/text");
/**
 * <mm-caption>
 * 보조 설명, 메타 정보, 이미지 캡션처럼 본문보다 낮은 위계의 텍스트입니다.
 */
let Caption = class Caption extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-text as="span" size="12" weight="medium" color="light">
        <slot></slot>
      </mm-text>
    `;
    }
};
Caption = __decorate([
    (0, decorators_js_1.customElement)('mm-caption')
], Caption);
exports.Caption = Caption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FwdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNhcHRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUFpRDtBQUNqRCx5Q0FBc0M7QUFFdEM7OztHQUdHO0FBRUksSUFBTSxPQUFPLEdBQWIsTUFBTSxPQUFRLFNBQVEsZ0JBQVU7SUFDckMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozs7S0FJVixDQUFBO0lBQ0gsQ0FBQztDQUNGLENBQUE7QUFSWSxPQUFPO0lBRG5CLElBQUEsNkJBQWEsRUFBQyxZQUFZLENBQUM7R0FDZixPQUFPLENBUW5CO0FBUlksMEJBQU8ifQ==